import { Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { ComponentModeEnum } from '../enums/component-mode.enum'

@Directive({
    selector: '[ifShowMode]',
    standalone: false
})
export class ShowModeDirective {
    constructor(
        @Inject(TemplateRef) private templateRef: TemplateRef<any>,
        @Inject(ViewContainerRef) private viewContainer: ViewContainerRef
    ) { }

    @Input() set ifShowMode(mode: ComponentModeEnum) {
        this.viewContainer.clear()
        if (mode === ComponentModeEnum.SHOW) {
            this.viewContainer.createEmbeddedView(this.templateRef)
        }
    }
}